/* InsuredFrames Audio · comportamento del sito in stile Italian Tweaks (20/10/2026).
   Lingua EN/ES/IT come su italiantweaks.com (pallino), menu, pro che scorrono, update dal Discord, varianti prodotto.
   Tutto dentro try: se qualcosa va storto la pagina resta quella scritta dal Liquid (in inglese). */
(function () {
  'use strict';
  var D = window.ITWA_TEXTS || {};
  var LANGS = ['EN', 'ES', 'IT'];
  var KEY = 'app_lang';                      // stessa chiave di italiantweaks.com
  var html = document.documentElement;
  html.classList.add('ia-js');

  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  // ---------- lingua: scelta salvata > ?itw_lang > /es/ > browser > paese ----------
  var ES_C = 'ES AD MX AR CO CL PE VE EC GT CU BO DO HN PY SV NI CR PA UY PR GQ'.split(' ');
  var TZ_ES = /^(America\/(Mexico_City|Cancun|Merida|Monterrey|Matamoros|Chihuahua|Ojinaga|Mazatlan|Bahia_Banderas|Hermosillo|Tijuana|Argentina|Buenos_Aires|Cordoba|Catamarca|Jujuy|Mendoza|Bogota|Santiago|Punta_Arenas|Lima|Caracas|Guayaquil|Guatemala|Havana|La_Paz|Santo_Domingo|Tegucigalpa|Asuncion|El_Salvador|Managua|Costa_Rica|Panama|Montevideo|Puerto_Rico)|Europe\/Madrid|Atlantic\/Canary|Africa\/Ceuta|Africa\/Malabo|Europe\/Andorra)/;
  function detect() {
    var s = (store(KEY) || '').toUpperCase();
    if (LANGS.indexOf(s) >= 0) return s;
    var q = (new URLSearchParams(location.search).get('itw_lang') || '').toUpperCase();
    if (LANGS.indexOf(q) >= 0) { store(KEY, q); return q; }
    if (/^\/es(\/|$)/.test(location.pathname)) return 'ES';
    if (/^\/it(\/|$)/.test(location.pathname)) return 'IT';
    var nl = navigator.languages || [navigator.language || ''];
    for (var i = 0; i < nl.length; i++) {
      var l = String(nl[i]).slice(0, 2).toLowerCase();
      if (l === 'it') return 'IT';
      if (l === 'es') return 'ES';
      if (l === 'en') break;
    }
    var c = ((window.Shopify && Shopify.country) || '').toUpperCase();
    if (c === 'IT' || c === 'SM' || c === 'VA') return 'IT';
    if (ES_C.indexOf(c) >= 0) return 'ES';
    try { var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; if (TZ_ES.test(tz)) return 'ES'; if (tz === 'Europe/Rome' || tz === 'Europe/San_Marino' || tz === 'Europe/Vatican') return 'IT'; } catch (e) { }
    return 'EN';
  }
  var lang = 'EN';
  try { lang = detect(); } catch (e) { }

  function t(key) {
    var d = D[lang] || {}, e = D.EN || {};
    return d[key] != null ? d[key] : (e[key] != null ? e[key] : null);
  }
  window.itwaT = t;

  function apply() {
    html.lang = lang.toLowerCase();
    var nodes = document.querySelectorAll('[data-t]');
    for (var i = 0; i < nodes.length; i++) {
      var v = t(nodes[i].getAttribute('data-t'));
      if (v != null) nodes[i].innerHTML = v;
    }
    var at = document.querySelectorAll('[data-t-attr]');
    for (var j = 0; j < at.length; j++) {
      at[j].getAttribute('data-t-attr').split(';').forEach(function (p) {
        var kv = p.split(':'); var v = t(kv[1]); if (v != null) at[j].setAttribute(kv[0], v.replace(/<[^>]+>/g, ''));
      });
    }
    var cur = document.querySelector('.ia-lang-cur');
    if (cur) cur.textContent = lang;
    var pill = document.querySelector('.ia-lang');
    if (pill) { pill.querySelector('.ia-flag').innerHTML = FLAGS[lang]; pill.title = NAMES[lang]; }
    // link al sito di Italian Tweaks nella stessa lingua (/it e /es: il sito parte in quella lingua)
    var il = document.querySelectorAll('a[data-itlink]');
    for (var n = 0; n < il.length; n++) {
      var a = il[n], base = a.getAttribute('data-href') || a.getAttribute('href');
      a.setAttribute('data-href', base);
      try { var u = new URL(base); var pre = lang === 'EN' ? '' : '/' + lang.toLowerCase(); a.setAttribute('href', u.origin + pre + (u.pathname === '/' && pre ? '' : u.pathname) + u.search); } catch (e) { }
    }
    var ck = document.querySelectorAll('[data-checkout]');
    for (var m = 0; m < ck.length; m++) ck[m].setAttribute('href', '/checkout?locale=' + lang.toLowerCase());
    renderUpdates();
  }
  // bandiere come su italiantweaks.com (SVG, EN = Union Jack)
  var FLAGS = {
    IT: '<svg viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice"><rect width="1" height="2" x="0" fill="#009246"/><rect width="1" height="2" x="1" fill="#F1F2F1"/><rect width="1" height="2" x="2" fill="#CE2B37"/></svg>',
    ES: '<svg viewBox="0 0 3 2" preserveAspectRatio="xMidYMid slice"><rect width="3" height="2" fill="#AA151B"/><rect width="3" height="1" y="0.5" fill="#F1BF00"/></svg>',
    EN: '<svg viewBox="0 0 60 30" preserveAspectRatio="xMidYMid slice"><rect width="60" height="30" fill="#012169"/><path d="M0,0 60,30 M60,0 0,30" stroke="#F1F2F1" stroke-width="7"/><path d="M0,0 60,30 M60,0 0,30" stroke="#C8102E" stroke-width="2.5"/><path d="M30,0 v30 M0,15 h60" stroke="#F1F2F1" stroke-width="11"/><path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6.5"/></svg>'
  };
  var NAMES = { EN: 'English', ES: 'Español', IT: 'Italiano' };

  // ---------- pallino della lingua ----------
  function initLang() {
    var pill = document.querySelector('.ia-lang');
    if (!pill) return;
    pill.addEventListener('click', function () { lang = lang === 'EN' ? 'ES' : lang === 'ES' ? 'IT' : 'EN'; store(KEY, lang); apply(); });
  }

  // ---------- menu da telefono ----------
  function initDrawer() {
    var dr = document.querySelector('.ia-drawer');
    if (!dr) return;
    var open = function (v) { dr.classList.toggle('is-open', v); document.body.style.overflow = v ? 'hidden' : ''; };
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { open(true); }); });
    dr.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { open(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
  }

  // ---------- comparsa allo scroll ----------
  function initReveal() {
    var els = document.querySelectorAll('.ia-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  // ---------- pro che usano l'audio ----------
  var XSVG = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.9 2H22l-6.8 7.8L23.2 22h-6.3l-4.9-6.4L6.4 22H3.3l7.3-8.3L2.8 2h6.4l4.4 5.8L18.9 2Zm-1.1 18.1h1.7L7.4 3.8H5.6l12.2 16.3Z"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.4 2.2 3.2-.4.9 3.1 2.9 1.5-1 3.1 1 3.1-2.9 1.5-.9 3.1-3.2-.4L12 22l-2.4-2.2-3.2.4-.9-3.1-2.9-1.5 1-3.1-1-3.1 2.9-1.5.9-3.1 3.2.4L12 2Zm-1.2 13.6 6-6-1.4-1.4-4.6 4.6-2.2-2.2-1.4 1.4 3.6 3.6Z"/></svg>';
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function initPros() {
    var host = document.querySelector('[data-pros]');
    var data = window.ITWA_PROS;
    if (!host || !data || !data.pros) return;
    var base = window.ITWA_ASSETS || '';
    var cards = data.pros.map(function (p) {
      var av = p.avatar ? '<img src="' + esc(base + p.avatar) + '" alt="" loading="lazy" width="46" height="46">' : esc(p.nome.slice(0, 1));
      return '<a class="ia-pro" href="https://x.com/' + esc(p.handle) + '" target="_blank" rel="noopener"><span class="ia-pro-av">' + av + '</span><span><span class="ia-pro-name">' + esc(p.nome) + CHECK + '</span><span class="ia-pro-handle">@' + esc(p.handle) + '</span></span><span class="ia-pro-x">' + XSVG + '</span></a>';
    });
    var half = Math.ceil(cards.length / 2);
    var rows = [cards.slice(0, half), cards.slice(half)];
    var out = rows.map(function (r, i) {
      return '<div class="ia-marquee' + (i % 2 ? ' ia-marquee--rev' : '') + '" style="--ia-speed:' + (r.length * 9) + 's"><div class="ia-track">' + r.join('') + r.join('').replace(/<a /g, '<a aria-hidden="true" tabindex="-1" ') + '</div></div>';
    });
    host.innerHTML = out.join('');
  }

  // ---------- annunci (dal Discord, tramite il tracker; al posto del changelog dal 21/10/2026) ----------
  var feed = null, feedErr = false;
  // «Insured Tune Guardian» / «Guardian» sempre in ciano (richiesta di Danilo del 21/10/2026)
  function hl(x) { return esc(x).replace(/Insured Tune Guardian|Guardian/g, function (m) { return '<span class="ia-cyan">' + m + '</span>'; }); }
  var LI = function (x) { return '<li>' + hl(x) + '</li>'; };
  var DL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12M7 10l5 5 5-5M4 20h16"/></svg>';
  function fmtDate(iso) {
    try { return new Date(iso + 'T12:00:00Z').toLocaleDateString({ EN: 'en-US', ES: 'es-ES', IT: 'it-IT' }[lang], { day: 'numeric', month: 'long', year: 'numeric' }); } catch (e) { return String(iso).slice(0, 10); }
  }
  function pick(o) { return o ? (o[lang] || o.EN) : ''; }
  function renderUpdates() {
    var host = document.querySelector('[data-announcements]');
    if (!host) return;
    if (feedErr) { host.innerHTML = '<p class="ia-updates-empty">' + t('ann.error') + '</p>'; return; }
    if (!feed) return;
    host.innerHTML = '<div class="ia-updates">' + (feed.entries || []).map(function (e, i) {
      var chips = i === 0 ? '<span class="ia-chip"><span class="ia-dot"></span>' + t('ann.latest') + '</span>' : '';
      var dl = e.download ? '<a class="ia-up-dl" href="' + esc(feed.discord) + '" target="_blank" rel="noopener">' + DL + t('ann.dl') + '</a>' : '';
      return '<article class="ia-up"><span class="ia-up-dot"></span><div class="ia-up-card"><div class="ia-up-top">' + chips + '<span class="ia-up-date">' + esc(fmtDate(e.date)) + '</span></div>' +
        '<h3>' + hl(pick(e.title)) + '</h3><ul class="ia-up-list">' + (pick(e.items) || []).map(LI).join('') + '</ul>' + dl + '</div></article>';
    }).join('') + '</div>';
  }
  function initUpdates() {
    if (!document.querySelector('[data-announcements]') || !window.ITWA_ANNOUNCEMENTS_URL) return;
    fetch(window.ITWA_ANNOUNCEMENTS_URL, { mode: 'cors', credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { feed = j; renderUpdates(); })
      .catch(function () { feedErr = true; renderUpdates(); });
  }

  // ---------- vouch sulle card dei pack: a ogni passaggio del mouse uno diverso (come su Italian Tweaks) ----------
  var STARS = '★★★★★';
  function initVouch() {
    var list = (window.ITWA_VOUCH || []).filter(function (v) { return v.avatar; });
    if (!list.length) return;
    var base = window.ITWA_ASSETS || '';
    document.querySelectorAll('[data-vouch]').forEach(function (box, n) {
      var card = box.closest('.ia-pack');
      var i = (n * 3) % list.length;
      var show = function () {
        var v = list[i];
        var av = base + v.avatar;
        box.innerHTML = '<div class="ia-vouch-top"><div class="ia-vouch-who"><img src="' + esc(av) + '" alt="" width="40" height="40" loading="lazy"><div><b>' + esc(v.name) + '</b><small>' + esc(v.username) + '</small></div></div><span class="ia-vouch-tag">' + esc(v.game || '') + '</span></div>' +
          '<div class="ia-vouch-stars" aria-hidden="true">' + STARS + '</div><p>"' + esc(v.text) + '"</p>';
      };
      show();
      if (card) card.addEventListener('mouseenter', function () { i = (i + 1) % list.length; show(); });
    });
  }

  // ---------- pagina prodotto: varianti ----------
  function initProduct() {
    var form = document.getElementById('ia-product-form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-ia-price]');
    var selfBox = form.querySelector('[data-self-fields]');
    var addBtn = form.querySelector('[name="add"]');
    function sync() {
      var r = form.querySelector('input[data-variant]:checked');
      var self = !!(r && r.getAttribute('data-vk') === 'self' && selfBox);
      if (selfBox) {
        selfBox.hidden = !self;
        selfBox.querySelectorAll('input').forEach(function (i) { i.disabled = !self; if (i.type !== 'hidden') i.required = self; });
      }
      // Meety mette il suo pulsante nel form: visibile solo per l'installazione con i professionisti
      form.querySelectorAll('.meety-block-buttons, .meety-block-button').forEach(function (m) { m.style.setProperty('display', self ? 'none' : '', self ? 'important' : ''); });
      if (addBtn && selfBox) addBtn.style.setProperty('display', self ? 'flex' : 'none', 'important');
    }
    if (window.MutationObserver) new MutationObserver(function () { sync(); }).observe(form, { childList: true, subtree: true });
    // Discord ID: formato giusto e membro del server di Italian Tweaks (controllo del tracker); se il controllo non
    // risponde si accetta il formato, per non bloccare le vendite
    var dcIn = form.querySelector('[data-discord-input]'), dcId = form.querySelector('[data-discord-id]'), dcUser = form.querySelector('[data-discord-user]'), dcSt = form.querySelector('[data-discord-status]');
    var dcPending = null, dcTimer = null, dcLast = '';
    function dcParse(v) { v = String(v || '').trim().replace(/^@/, ''); if (/^\d{17,20}$/.test(v)) return v; v = v.replace(/#0$/, '').toLowerCase(); return /^(?!.*\.\.)[a-z0-9_.]{2,32}$/.test(v) ? v : null; }
    function dcShow(cls, html, invalid) { dcSt.className = 'ia-dc' + (cls ? ' ' + cls : ''); dcSt.innerHTML = html; dcIn.setCustomValidity(invalid ? dcSt.textContent : ''); }
    function dcCheck() {
      var raw = dcIn.value, v = dcParse(raw);
      dcId.value = ''; dcUser.value = '';
      if (!raw.trim()) { dcShow('', '', true); return Promise.resolve(false); }
      if (!v) { dcShow('is-bad', t('pr.dc.format'), true); return Promise.resolve(false); }
      if (v === dcLast && dcPending) return dcPending;
      dcLast = v;
      dcShow('', t('pr.dc.checking'), true);
      var url = window.ITWA_DISCORD_CHECK_URL;
      dcPending = (url ? fetch(url + '?q=' + encodeURIComponent(v), { mode: 'cors', credentials: 'omit' }).then(function (r) { return r.json(); }) : Promise.reject())
        .then(function (j) {
          if (dcParse(dcIn.value) !== v) return false;
          if (j && j.ok) { dcId.value = j.id; dcUser.value = j.username; dcShow('is-ok', t('pr.dc.ok').replace('{u}', esc(j.username)), false); return true; }
          if (j && (j.reason === 'not_member' || j.reason === 'format')) { dcShow('is-bad', t(j.reason === 'format' ? 'pr.dc.format' : 'pr.dc.notmember'), true); return false; }
          throw new Error('unavailable');
        })
        .catch(function () { if (dcParse(dcIn.value) !== v) return false; dcId.value = v; dcShow('', t('pr.dc.unavailable'), false); return true; });
      return dcPending;
    }
    if (dcIn) {
      dcIn.addEventListener('input', function () { clearTimeout(dcTimer); dcLast = ''; dcPending = null; dcTimer = setTimeout(dcCheck, 600); });
      dcIn.addEventListener('blur', function () { clearTimeout(dcTimer); dcCheck(); });
    }
    form.addEventListener('submit', function (e) {
      if (!selfBox || selfBox.hidden) return;
      if (dcIn && !dcId.value) {
        e.preventDefault();
        dcCheck().then(function (ok) { if (ok && form.checkValidity()) form.requestSubmit ? form.requestSubmit(addBtn) : form.submit(); else form.reportValidity(); });
        return;
      }
      if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); }
    });
    form.querySelectorAll('input[data-variant]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        idInput.value = r.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        if (priceEl && r.getAttribute('data-price')) priceEl.innerHTML = r.getAttribute('data-price');
        try { var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u); } catch (e) { }
        sync();
      });
    });
    sync();
  }

  function init() {
    try { initLang(); } catch (e) { }
    try { initDrawer(); } catch (e) { }
    try { initPros(); } catch (e) { }
    try { initProduct(); } catch (e) { }
    try { initUpdates(); } catch (e) { }
    try { initVouch(); } catch (e) { }
    try { apply(); } catch (e) { }
    try { initReveal(); } catch (e) { }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
